import React from "react";

const Home = () => {
    return (
        <div
            className="container-fluid d-flex justify-content-center align-items-center"
            style={{
                width: "100vw",
                height: "100vh",
                backgroundImage: "url('/fondo.jpg')",
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            {/* Contenido opcional aquí */}
        </div>
    );
};

export default Home;
